// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import './assets/iconfont/iconfont.css'
import 'default-passive-events'  //去除控制台窗口警告 non-passive event listener
import VueRouter from 'vue-router'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { Message,Loading } from 'element-ui'
import echarts from 'echarts'
import {publicData} from './assets/js/data.js'//引用模块进来
import BaiduMap from 'vue-baidu-map'
import vueFilter from './assets/js/filter'
import App from './App'

for (let key in vueFilter){
  Vue.filter(key,vueFilter[key])
}

import DataExpress from './components/DataExpress'
import FundRecharge from './components/FundRecharge'
import ProjectNew from './components/ProjectNew'
import OrderList from './components/OrderList'
import ProjectManage from './components/ProjectManage'
import OrderAbnormal from './components/OrderAbnormal'
import FundInfo from './components/FundInfo'
import PersonInfo from './components/PersonInfo'
import PersonMaintain from './components/PersonMaintain'
import ProjectNewDetail from './components/ProjectNewDetail'
import IdentityCompanyInfo from './components/IdentityCompanyInfo'
import IdentityOperatingRecord from './components/IdentityOperatingRecord'
import IdentityUserPassword from './components/IdentityUserPassword'
import IdentityCompanyLCE from './components/IdentityCompanyLCE'
import PersonnelSigning from './components/PersonnelSigning'
import OrderDetail from './components/OrderDetail'
import InvoiceList from './components/InvoiceList'
import InvoiceDetail from './components/InvoiceDetail'
import InvoiceAddr from './components/InvoiceAddr'
import ProjectAbandon from './components/ProjectAbandon'
import OrderTask from './components/OrderTask'
import LhygCompanyAddr from './components/LhygCompanyAddr'
import LhygCompanyInfo from './components/LhygCompanyInfo'
import BankList from './components/BankList'
import FundInfoDetail from './components/FundInfoDetail'




//使用
Vue.use(VueRouter)
Vue.use(ElementUI)
Vue.use(BaiduMap, {
    ak: 'l40B1mkg9tPquS6YXMINrQ4p9ObxrjWl'
})
//配置
Vue.prototype.$http = axios
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false


var loading;
function startLoading() {
	loading = Loading.service({
		lock: true,
		text: '加载中……',
		background: 'rgba(0, 0, 0, 0.05)'
	})
}
function endLoading() {
    loading.close()
}
// 全局配置默认路由
// axios.defaults.baseURL = 'http://apitest.zfy.drkjjt.com/index.php/';
// 添加请求拦截器
axios.interceptors.request.use(function (config) {
	if(publicData.isShowLoading==true){ //全局变量 true  时loading开启
		startLoading();
	}
	 // 这里的config包含每次请求的内容
	  let token = window.sessionStorage.getItem('token')
	  if (token) {
	    // 添加headers
	    config.headers.Authorization = `${token}`;
	    config.headers['content-type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
	  } else {}
    return config;
  }, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
	console.log('我是请求error')
});

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
	endLoading();
    return response;
  }, function (error) {
	endLoading();
    return Promise.reject(error);
});

const router = new VueRouter({
	routes:[
			{
				path: '/',
				redirect: {
					name: 'dataExpress',
				}
			},{
				path:'/dataExpress', //数据列表
				name:'dataExpress',
				component:DataExpress
			},{
				path:'/projectNew',//新建项目
				name:'projectNew',
				component:ProjectNew
			},{
				path:'/projectNewDetail',//上传的项目表
				name:'projectNewDetail',
				component:ProjectNewDetail
			},{
				path:'/orderList',//订单列表
				name:'orderList',
				component:OrderList
			},{
				path:'/projectManage',//项目管理
				name:'projectManage',
				component:ProjectManage
			},{
				path:'/orderAbnormal',//异常数据
				name:'orderAbnormal',
				component:OrderAbnormal
			},{
				path:'/projectAbandon',//作废项目
				name:'projectAbandon',
				component:ProjectAbandon
			},{
				path:'/fundRecharge',//充值
				name:'fundRecharge',
				component:FundRecharge
			},{
				path:'/fundInfo',//收支明细
				name:'fundInfo',
				component:FundInfo
			},{
				path:'/fundInfoDetail',//流水记录
				name:'FundInfoDetail',
				component:FundInfoDetail
			},{
				path:'/personInfo',//人员信息
				name:'personInfo',
				component:PersonInfo
			},{
				path:'/personMaintain',//人员维护
				name:'personMaintain',
				component:PersonMaintain
			},{
				path:'/companyInfo',//企业资料
				name:'companyInfo',
				component:IdentityCompanyInfo
			},{
				path:'/operatingRecord',//操作记录
				name:'operatingRecord',
				component:IdentityOperatingRecord
			},{
				path:'/userPassword',//账户密码
				name:'userPassword',
				component:IdentityUserPassword
			},{
				path:'/identityCompanyLCE',//资质及账户
				name:'identityCompanyLCE',
				component:IdentityCompanyLCE
			},{
				path:'/personnelSigning',//人员认证签约
				name:'personnelSigning',
				component:PersonnelSigning
			},{
				path:'/orderDetail',//订单详情
				name:'orderDetail',
				component:OrderDetail
			},{
				path:'/invoiceList',//发票申请列表
				name:'invoiceList',
				component:InvoiceList
			},{
				path:'/invoiceDetail',//发票详情/审核
				name:'invoiceDetail',
				component:InvoiceDetail
			},{
				path:'/invoiceAddr',//发票地址
				name:'invoiceAddr',
				component:InvoiceAddr
			},{
				path:'/orderTask',//订单 任务派单
				name:'orderTask',
				component:OrderTask
			},{
				path:'/lhygCompanyAddr',//灵活用工 企业地址
				name:'lhygCompanyAddr',
				component:LhygCompanyAddr
			},{
				path:'/lhygCompanyInfo',//灵活用工 企业地址
				name:'lhygCompanyInfo',
				component:LhygCompanyInfo
			}, {
				path:'/bankList',//银行卡列表
				name:'bankList',
				component:BankList
			},
			
			
	]
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { 
  		App,
		DataExpress,
		FundRecharge,
		ProjectNew,
		OrderList,
		ProjectManage,
		OrderAbnormal,
		FundInfo,
		PersonInfo,
		PersonMaintain,
		ProjectNewDetail,
		IdentityCompanyInfo,
		IdentityOperatingRecord,
		IdentityUserPassword,
		IdentityCompanyLCE,
		PersonnelSigning,
		OrderDetail,
		InvoiceList,
		InvoiceDetail,
		InvoiceAddr,
		ProjectAbandon,
		OrderTask,
		LhygCompanyAddr,
		LhygCompanyInfo,
		BankList,
		FundInfoDetail
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js